import {
    addSelectionToBetslip,
    removeSelectionFromBetslip,
    addSelectionsToBetslip,
} from '~Betslip/interface/interactions';

/**
 * Toggle selection into Betslip
 * @param {String} selectionId Id of the selection to be add/remove
 * @param {Object} isSelected The selection object to check if it's
 * already in Betslip
 * @param {String} betLocate where the user placed the bet from
 * @param {Boolean} isScorecast whether the bet is scorecast or not
 * @param {Boolean} isMulti whether the bet is a multibet or not
 * @return {void} returns a function to add/remove a selection to Betslip
 */
export const toggleSelectionToBetslip = (
    selectionId,
    isSelected,
    betLocate = 'unknown_component',
    isScorecast,
    isMulti,
) => {
    if (isMulti) {
        const ids = selectionId.split('_');

        return isSelected
            ? ids.forEach(id => removeSelectionFromBetslip(id))
            : addSelectionsToBetslip(ids);
    }

    return isSelected
        ? removeSelectionFromBetslip(selectionId)
        : addSelectionToBetslip(selectionId, { is_scorecast: isScorecast, bet_locate: betLocate });
};
